import React from 'react';
import { motion } from 'framer-motion';
import PricingCard from './PricingCard';

const Pricing = () => {
  const plans = [
    { name: "Essential", price: "297", features: [ "4 videos per month", "48h turnaround", "Basic cuts & captions", "Basic colour correction", "Unlimited revisions", "Cloud delivery" ] },
    { name: "Executive", price: "497", highlight: true, mostPopular: true, features: [ "8 videos per month", "24h priority turnaround", "Advanced colour grading", "Custom captions & hooks", "Light motion graphics", "Platform-optimised exports" ] },
    { name: "Studio", price: "797", features: [ "16 videos per month", "Dedicated editor", "Same-day turnaround", "Full visual identity", "Trend analysis", "Advanced motion graphics" ] },
    { name: "Unlimited", price: "Let's Talk", isUnlimited: true, features: [ "Unlimited requests", "Unlimited revisions", "Dedicated team", "Custom workflows", "Priority turnaround", "Strategy & planning" ] }
  ];

  return (
    <section id="pricing" className="bg-black py-10 md:py-32 section-curve-up">
      <div className="max-w-[1400px] mx-auto px-6">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.6 }} 
          viewport={{ once: true }} 
          className="text-3xl md:text-7xl font-black text-white tracking-tighter leading-none text-center mb-8 md:mb-24 uppercase" 
        >
          SUBSCRIPTION <span className="text-[#BEF264]">MODELS</span>
        </motion.h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 items-stretch">
          {plans.map((plan, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1, duration: 0.6 }} viewport={{ once: true }} >
              <PricingCard plan={plan} index={i} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;